module.exports = __webpack_public_path__ + "img/special_ultraDark.42a0531f.png";